export const airQualityLabel: Record<number, string> = {
  1: 'Bom',
  2: 'Regular',
  3: 'Moderado',
  4: 'Ruim',
  5: 'Muito Ruim',
  6: '',
}

export const airQualityColors: { [key: number]: string } = {
  1: '#87ebcd',
  2: '#FFC107',
  3: '#FF9800',
  4: '#F44336',
  5: '#6A1B9A',
}
